import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { ApercuFacture, BadgeFacture, DialogFacture, fmt2, telechargerBlob } from './ApercuFacture';

const API = process.env.REACT_APP_BACKEND_URL;

// 🧾 Phase 6 : onglet « Mes factures » du Marché du Store (installateur).
export function MesFacturesOnglet({ installateurId, anneeInitiale }) {
  const [annee, setAnnee] = useState(anneeInitiale || new Date().getFullYear());
  const [factures, setFactures] = useState([]);
  const [erreur, setErreur] = useState('');
  const [ouverte, setOuverte] = useState(null);
  useEffect(() => {
    setErreur('');
    axios.get(`${API}/api/lmds/installateurs/${installateurId}/factures?annee=${annee}`)
      .then((r) => setFactures(r.data.factures || []))
      .catch((e) => setErreur(e?.response?.data?.detail || 'Impossible de charger les factures.'));
  }, [installateurId, annee]);
  const annees = [annee + 1, annee, annee - 1, annee - 2].sort((a, b) => b - a);
  const actives = factures.filter((f) => f.statut !== 'annulee');
  return (
    <div className="space-y-4" data-testid="onglet-mes-factures">
      <div className="flex flex-wrap items-center gap-3">
        <h3 className="font-semibold">Mes factures</h3>
        <select className="border rounded-md h-9 px-2 text-sm bg-white" value={annee} onChange={(e) => setAnnee(parseInt(e.target.value))} data-testid="factures-annee">
          {[...new Set(annees)].map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <Button variant="outline" size="sm" disabled={!actives.length} data-testid="factures-zip"
          onClick={() => telechargerBlob(`${API}/api/lmds/installateurs/${installateurId}/factures/zip?annee=${annee}`, `factures-${annee}.zip`, false)}>
          Télécharger toutes les factures {annee}
        </Button>
      </div>
      <p className="text-xs text-slate-500">Une facture est émise automatiquement lorsque le mois est marqué payé. Si une semaine est corrigée puis re-payée, une version corrigée (-R1, -R2…) est émise et l'originale est conservée, marquée « Remplacée ».</p>
      {erreur && <p className="text-sm text-red-600" data-testid="factures-erreur">{erreur}</p>}
      {!erreur && !factures.length && <p className="text-sm text-slate-500" data-testid="factures-vide">Aucune facture pour {annee}.</p>}
      {factures.length > 0 && (
        <table className="w-full text-sm" data-testid="table-mes-factures">
          <thead><tr className="text-left bg-slate-50"><th className="p-2">Numéro</th><th className="p-2">Semaine</th><th className="p-2">Période</th><th className="p-2 text-right">Montant final</th><th className="p-2">Statut</th><th className="p-2">Actions</th></tr></thead>
          <tbody>
            {factures.map((f) => (
              <tr key={f.id} className="border-b" data-testid={`facture-ligne-${f.numero}`}>
                <td className="p-2 font-mono">{f.numero}</td><td className="p-2">S{f.semaine}</td>
                <td className="p-2 text-xs">{f.periode?.debut} → {f.periode?.fin}</td>
                <td className="p-2 text-right font-semibold">{fmt2(f.montant_final)}</td>
                <td className="p-2"><BadgeFacture f={f} /></td>
                <td className="p-2 flex gap-1">
                  <Button size="sm" variant="outline" onClick={() => setOuverte(f.id)} data-testid={`facture-voir-${f.numero}`}>Voir</Button>
                  <Button size="sm" variant="ghost" onClick={() => telechargerBlob(`${API}/api/lmds/installateurs/${installateurId}/factures/${f.id}/pdf`, `${f.numero}.pdf`, true)} data-testid={`facture-imprimer-${f.numero}`}>Imprimer</Button>
                  <Button size="sm" variant="ghost" onClick={() => telechargerBlob(`${API}/api/lmds/installateurs/${installateurId}/factures/${f.id}/pdf`, `${f.numero}.pdf`, false)} data-testid={`facture-pdf-${f.numero}`}>PDF</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <DialogFacture installateurId={installateurId} factureId={ouverte} onFermer={() => setOuverte(null)} />
    </div>
  );
}

export { ApercuFacture };
